import React, { PureComponent } from 'react';

export const GanttChartContext = React.createContext();

export class GanttChartProvider extends PureComponent {
    render() {
        return (
            <GanttChartContext.Provider
                value={{
                    chartStart: this.props.chartStart,
                    dayWidth: this.props.dayWidth
                }}
            >
                { this.props.children }
            </GanttChartContext.Provider>
        );
    }
}
